import {XauditModel} from '../xaudit.model';
import {ITableData} from '../../modules/configuration/business-hours/models/i-table.data';

export class ScheduleTimesDaysConfigurationModel extends XauditModel implements ITableData {
  SchedultTimeDayID: string;
  LOCID: number;
  enumWeekDaysID: string;
  StartTime: string;
  EndTime: string;
}
